import {useIntersectionObserver} from './module/intersectionObserver'
import {SlideShowTouch, displaySlideHome, SlideShowOverlay, displaySlideArticle} from './module/slideshow'
import {useClosest, useArrayFrom, useSvg} from './module/polyfill'
import {reveal} from './module/scrollreveal'
import {contactMap, programsMap} from './module/map'
import Form from './module/form'

(function () {

	let body = document.body

	useSvg()
	useArrayFrom()
	useClosest()

	if (document.querySelector('.target-hidden'))
		reveal()

	if (document.querySelector('.map__contact') || document.querySelector('.program__map'))
		contactMap()

	if (document.querySelector('.offercard__map'))
		programsMap()

	if (document.querySelector('.contact-form')) {
		const formsNode = document.querySelectorAll('.contact-form')
		formsNode.forEach((formNode) => {
			const form = new Form(formNode)
			form.registerEvents()
		})        
	}


    const slideshowTouchInit = () => {

		let slideshow = document.querySelectorAll('.slideshow-touch')

		if (!slideshow) return 

		for (let i=0, lng=slideshow.length; i<lng; i++) {
			let slideshowItem = new SlideShowTouch(slideshow[i])
			slideshowItem.init()
		}

		window.onresize = function () {
			for (let i=0, lng=slideshow.length; i<lng; i++) {
				let slideshowItem = new SlideShowTouch(slideshow[i])
				slideshowItem.init()
			}
		}
	}
	slideshowTouchInit()

	/**
     * Lazyloading
     */
    const lazyLoad = () => {

		let lazyImages = Array.from(document.querySelectorAll('img.lazy'))
        
        let lazyImageObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {

                if (!entry.isIntersecting)
                    return

                let lazyImage = entry.target
                lazyImage.src = lazyImage.getAttribute('data-src')
				lazyImage.removeAttribute('data-src')
				

                if (lazyImage.getAttribute('data-srcset')) {
                	lazyImage.srcset = lazyImage.getAttribute('data-srcset')
					lazyImage.removeAttribute('data-srcset')
                }

                if (lazyImage.getAttribute('data-sizes')) {
                    lazyImage.sizes = lazyImage.getAttribute('data-sizes')
					lazyImage.removeAttribute('data-sizes')
				}
                
				lazyImage.classList.remove('lazy')
                lazyImageObserver.unobserve(lazyImage)
            })
        })

		lazyImages.forEach((lazyImage) => lazyImageObserver.observe(lazyImage))
    }

    if ('IntersectionObserver' in window)
		lazyLoad()


	/**
	 * Navigation
	 */
	const triggerNavbar = () => {
		document.querySelector('.menu').classList.toggle('trigger')
		body.classList.toggle('trigger')
	}

	const closeNavbar = () => {
		document.querySelector('.menu').classList.remove('trigger')
		body.classList.remove('trigger')
	}

	const displayTab = el => {
		let container = el.closest('.tab-container'),
			nodes     = Array.from(container.querySelectorAll('.tab-item')),
			current   = container.querySelector('.tab-item.trigger'),
			direction = (el.classList.contains('previous')) ? -1 : 1,
			index     = nodes.indexOf(current)

		index = index + direction 


		if (index < 0) index = nodes.length - 1
		if (index > nodes.length - 1) index = 0

		current.classList.remove('trigger')
		nodes[index].classList.add('trigger')
		container.querySelector('.tab-result').innerHTML = (index + 1) + '/' + nodes.length
	}

	const nextTab = () => {
		let container = document.querySelector('.tab-container'),
			nodes     = Array.from(container.querySelectorAll('.tab-item')),
			current   = container.querySelector('.tab-item.trigger'),
			direction = 1,
			index     = nodes.indexOf(current)

		index = index + direction

		if (index < 0) index = nodes.length - 1
		if (index > nodes.length - 1) index = 0

		current.classList.remove('trigger')
		nodes[index].classList.add('trigger')
		container.querySelector('.tab-result').innerHTML = (index + 1) + '/' + nodes.length
	}

	const eventTab = () => {
		let container = document.querySelector('.tab-container'),
			interval

		interval = setInterval(nextTab, 3000)

		container.addEventListener('mouseover', () => {
			clearInterval(interval)
		})

		container.addEventListener('mouseleave', () => {
			interval = setInterval(nextTab, 3000)
		})
	}

	if (document.querySelector('.tab-container'))
		eventTab()
		

	/**
	 * Slideshow Overlay
	 */
	const initSlideshowOverlay = () => {
		window.setInterval(sldieOverlay, 1000)
	}

	if (document.querySelector('.hero-overlay')) {
		let slideshow = new SlideShowOverlay(document.querySelector('.hero-overlay'), document.querySelector('.slideshow__overlay'))
		slideshow.registerEvents()
	}

	/**
	 * Dropdown
	 */
	const openDropDown = el => {
		el.nextElementSibling.classList.toggle('trigger')
	}

	const selectValue = el => {

		let parent  = el.closest('.selector'),
			trigger = parent.querySelector('.selector-trigger'),
			input   = parent.querySelector('input')
		
		trigger.innerHTML = el.getAttribute('data-value')
		input.value = el.getAttribute('data-value')
		el.parentElement.classList.remove('trigger')
	}

	const selectSPFilter = el => {
		el.classList.toggle('trigger')

		let filter = document.querySelector('.filters__sp__filter--trigger.trigger').querySelector('span'),
			group  = el.parentElement.querySelectorAll('.filters__sp__checkbox.trigger')

		if (group.length > 0)
			return filter.setAttribute('data-count', '(' + group.length + ')')

		return filter.setAttribute('data-count', '')
	}

	const submitSPFilters = el => {
		document.querySelector('.filters__sp__container').classList.remove('trigger')
		document.querySelector('.filters__sp__loader').classList.add('trigger')
	}

	const closeSPFilters = () => {
		document.querySelector('.filters__sp__container').classList.remove('trigger')
		
		let current = document.querySelector('.filters__sp__filter--trigger.trigger')

		if (current) return current.classList.remove('trigger')
	}

	const openSPFilters = el => {
		
		let current = document.querySelector('.filters__sp__filter--trigger.trigger')

		if (current && current !== el)
			current.classList.remove('trigger')

		el.classList.toggle('trigger')
	}

	const openPopup = el => el.classList.add('trigger')
	const closePopup = () => document.querySelector('.popup__open.trigger').classList.remove('trigger')
	const displayPopupSlide = el => {
		let container = el.closest('.popup'),
			slides    = Array.from(container.querySelectorAll('.popup__img')),
			current   = container.querySelector('.popup__img.trigger'),
			indexOf   = slides.indexOf(current),
			direction = el.classList.contains('previous') ? -1 : 1

		indexOf = indexOf + direction

		if (indexOf < 0) indexOf = slides.length - 1
		if (indexOf === slides.length) indexOf = 0

		current.classList.remove('trigger')
		slides[indexOf].classList.add('trigger')
	}

	const displayFitlersMode = el => {
		el.classList.toggle('trigger')
		document.querySelector('.offercard__container').classList.toggle('list')
	}

	const handleNavbar = () => {
		let navbar = document.querySelector('.navbar')

		if (window.scrollY > 0 && !navbar.classList.contains('scrolled'))
			return navbar.classList.add('scrolled')
		if (window.scrollY === 0 && navbar.classList.contains('scrolled'))
			return navbar.classList.remove('scrolled')
	}
	if (document.querySelector('.navbar'))
		handleNavbar()

	window.addEventListener('scroll', () => {
		if (document.querySelector('.navbar'))
			handleNavbar()
	})
	
    
    body.addEventListener('click', (e) => {

		let el = e.target

		if (!el.classList.contains('selector-opt-item') && document.querySelector('.selector__opt.trigger'))
			document.querySelector('.selector__opt.trigger').classList.remove('trigger')

        if (el.classList.contains('slideshow-home-item'))
			return displaySlideHome(el)
			
		if (el.classList.contains('menu-trigger'))
			return triggerNavbar()

		if (el.classList.contains('menu-close'))
			return closeNavbar()

		if (el.classList.contains('tab-controller'))
			return displayTab(el)

		if (el.classList.contains('selector-trigger'))
			return openDropDown(el)

		if (el.classList.contains('selector-opt-item'))
			return selectValue(el)

		if (el.classList.contains('accordion-trigger'))
			return el.classList.toggle('trigger')

		if (el.classList.contains('filters__sp__filter--trigger'))
			return openSPFilters(el)

		if (el.classList.contains('filters__sp__filter--close'))
			return document.querySelector('.filters__sp__filter--trigger.trigger').classList.remove('trigger')

		if (el.classList.contains('filters__sp__checkbox'))
			return selectSPFilter(el)

		if (el.classList.contains('filters__sp__submit'))
			return submitSPFilters(el)

		if (el.classList.contains('filters__sp__open'))
			return document.querySelector('.filters__sp__container').classList.add('trigger')

		if (el.classList.contains('filters__sp__close'))
			return closeSPFilters()

		if (el.classList.contains('popup__open'))
			return openPopup(el)

		if (el.classList.contains('popup__controller'))
			return displayPopupSlide(el)

		if (el.classList.contains('popup__close'))
			return closePopup()

		if (el.classList.contains('filters__display__item'))
			return displayFitlersMode(el)

		if (el.classList.contains('article__controller'))
			return displaySlideArticle(el)

		if (el.classList.contains('menu-search'))
			return document.querySelector('.modal__search').classList.add('trigger')
		if (el.classList.contains('menu-search-close'))
			return document.querySelector('.modal__search').classList.remove('trigger')
    })
})()

